// ─── Ovvo Camping — Analytics Tracker ───────────────────────────────────────
// Genera visitor/session ID, rileva UTM, traccia pageview e tempo sulla pagina.

import { getConsent } from "./consent";

const API_URL = "/api/analytics/track";

function uuid(): string {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

function getOrCreate(storage: Storage, key: string): string {
  let val = storage.getItem(key);
  if (!val) { val = uuid(); storage.setItem(key, val); }
  return val;
}

function getUtm() {
  const p = new URLSearchParams(window.location.search);
  return {
    utmSource:   p.get("utm_source")   || undefined,
    utmMedium:   p.get("utm_medium")   || undefined,
    utmCampaign: p.get("utm_campaign") || undefined,
    utmContent:  p.get("utm_content")  || undefined,
    utmTerm:     p.get("utm_term")     || undefined,
  };
}

// Track entry time to compute time-on-page
let pageStartTime = Date.now();
let currentPage   = typeof window !== "undefined" ? window.location.pathname : "";
let sentPages     = new Set<string>();

export function trackPageView() {
  try {
    if (getConsent() !== "accepted") return;
    const visitorId  = getOrCreate(localStorage,   "ovvo_vid");
    const sessionId  = getOrCreate(sessionStorage,  "ovvo_sid");
    const isNewVisitor  = !localStorage.getItem("ovvo_visited");
    const isNewSession  = !sessionStorage.getItem("ovvo_s_started");

    if (isNewVisitor) localStorage.setItem("ovvo_visited", "1");
    if (isNewSession) sessionStorage.setItem("ovvo_s_started", Date.now().toString());

    const payload = {
      visitorId,
      sessionId,
      page: window.location.pathname,
      referrer: document.referrer || undefined,
      ...getUtm(),
      deviceType:  detectDevice(),
      screenWidth:  window.screen.width,
      screenHeight: window.screen.height,
      language: navigator.language,
      isNewVisitor,
      isNewSession,
    };

    // Reset timer for new page
    pageStartTime = Date.now();
    currentPage = window.location.pathname;
    sentPages = new Set([currentPage]);

    const body = new Blob([JSON.stringify(payload)], { type: "application/json" });
    navigator.sendBeacon
      ? navigator.sendBeacon(API_URL, body)
      : fetch(API_URL, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload), keepalive: true }).catch(() => {});
  } catch (_) { /* silently ignore */ }
}

function detectDevice() {
  const ua = navigator.userAgent;
  if (/tablet|ipad|playbook|silk/i.test(ua)) return "tablet";
  if (/mobile|iphone|ipod|android.*mobile|blackberry|opera mini/i.test(ua)) return "mobile";
  return "desktop";
}

export function sendTimeOnPage() {
  try {
    if (getConsent() !== "accepted") return;
    const elapsed = Math.round((Date.now() - pageStartTime) / 1000);
    if (elapsed < 1) return;
    const sessionId = sessionStorage.getItem("ovvo_sid");
    if (!sessionId) return;
    const payload = { sessionId, page: currentPage, timeOnPage: elapsed };
    const body = new Blob([JSON.stringify(payload)], { type: "application/json" });
    navigator.sendBeacon
      ? navigator.sendBeacon("/api/analytics/time", body)
      : fetch("/api/analytics/time", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload), keepalive: true }).catch(() => {});
  } catch (_) {}
}

// Send time on page when user leaves
if (typeof window !== "undefined") {
  window.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") sendTimeOnPage();
  });
  window.addEventListener("pagehide", sendTimeOnPage);
}
